/*
 * Public API Surface of @mmscan/angular-ui/spinner
 */

export * from './spinner';
